import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationDialogComponent } from './confirmation-dialog.component';

@Injectable()
export class ConfirmationDialogService {

  // Constructor to inject the NgbModal service
  constructor(private modalService: NgbModal) { }

  /**
   * Opens a confirmation dialog with the specified title, message, and button texts.
   * @param title The title of the confirmation dialog.
   * @param message The message or content of the confirmation dialog.
   * @param btnOkText The text for the 'OK' button (default: 'OK').
   * @param btnCancelText The text for the 'Cancel' button (default: 'Cancel').
   * @param dialogSize The size of the dialog (small or large, default: 'sm').
   * @returns A Promise that resolves to true when the user clicks 'OK', and false when the user clicks 'Cancel'.
   */
  public confirm(
    title: string,
    message: string,
    btnOkText: string = 'OK',
    btnCancelText: string = 'Cancel',
    dialogSize: 'sm'|'lg' = 'sm'
  ): Promise<boolean> {
    // Open the confirmation dialog using the NgbModal service
    const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize });

    // Set properties on the ConfirmationDialogComponent instance to display the correct content
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    // Return the result as a Promise (true when 'OK' is clicked, false when 'Cancel' is clicked)
    return modalRef.result;
  }

}
